export enum Language {
	EN = 'en',
	ES = 'es',
	FR = 'fr'
}